$(() => {
  $.fn.scotiabank = function Plugin(options) {
    const defaults = {
      i18n: {
        error: null,
      },
    };
    const settings = $.extend(true, {}, defaults, options);
    const selectors = {
      isEmployeeForm: '[data-js-scotiabank-is-employee-form]',
      isEmployee: '[data-js-scotiabank-is-employee]',
      isNotEmployee: '[data-js-scotiabank-is-not-employee]',
      nextSteps: '[data-js-scotiabank-next-steps]',
      selectEmployees: '[data-js-scotiabank-select-employees]',
      selectEmployeesForm: '[data-js-scotiabank-select-employees-form]',
      discounts: '[data-js-scotiabank-discounts]',
      discount: '[data-js-scotiabank-discount]',
      discountsForm: '[data-js-scotiabank-discounts-form]',
      discountOption: '[data-js-scotiabank-discount-option]',
      discountFundraisingAcknowledgements: '[data-js-scotiabank-discount-fundraising-acknowledgements]',
    };
    const $container = $(this);
    const elements = {
      $container,
      $isEmployeeForm: $container.find(selectors.isEmployeeForm),
      $isEmployee: $container.find(selectors.isEmployee),
      $isNotEmployee: $container.find(selectors.isNotEmployee),
      $nextSteps: $container.find(selectors.nextSteps),
      $snackBar: $('[data-js-snack-bar]'),
    };
    let canSubmit = false;

    const alertErrors = (response) => {
      const { errors } = response.responseJSON;

      if (errors && errors.length) {
        errors.forEach((error) => {
          elements.$snackBar.snackBar('add', {
            type: 'danger',
            icon: 'exclamation-circle',
            content: error.detail,
          });
        });

        return;
      }

      elements.$snackBar.snackBar('add', {
        type: 'danger',
        icon: 'exclamation-circle',
        content: settings.i18n.error,
      });
    };

    /**
         * Do showy hidey things for the discount options
         * @param nextUrl
         */
    const initializeDiscountOptions = (nextUrl) => {
      const $form = $container.find(selectors.discountsForm);
      const $discountOption = $container.find(selectors.discountOption);

      $form.preventDoubleSubmission();

      $form.on('submit', (event) => {
        event.preventDefault();

        $.ajax({
          url: nextUrl,
          data: $form.serialize(),
          type: 'POST',
        })
          .done((response) => {
            document.location = response.nextUrl;
          })
          .fail((response) => {
            alertErrors(response);
            $form.trigger('raceRoster.preventDoubleSubmission.reEnable');
          });
      });

      $discountOption.on('change', (event) => {
        const $this = $(event.currentTarget);
        const $fundraisingAcknowledgements = $this
          .closest(selectors.discount)
          .find(selectors.discountFundraisingAcknowledgements);
        const isFundraising = $this.val() === 'RUNNING_AND_FUNDRAISING';

        $fundraisingAcknowledgements
          .toggleClass('hidden', !isFundraising)
          .prop('disabled', !isFundraising);
      });

      $discountOption.filter(':checked').trigger('change');
    };

    /**
         * Moves onto the discount questions step
         * @param data
         */
    const completeEmployeeSelection = (data) => {
      elements.$nextSteps.html($(data.content).find(selectors.discounts).html());
      initializeDiscountOptions(data.nextUrl);
    };

    /**
         * Grabs the employee selection form
         * @param nextUrl
         */
    const initializeEmployeeSelection = (nextUrl) => {
      const $form = elements.$container.find(selectors.selectEmployeesForm);

      $form.preventDoubleSubmission();

      $form.on('submit', (event) => {
        event.preventDefault();

        $.ajax({
          url: nextUrl,
          data: $form.serialize(),
          type: 'post',
        })
          .done(completeEmployeeSelection)
          .fail((response) => {
            alertErrors(response);
            $form.trigger('raceRoster.preventDoubleSubmission.reEnable');
          });
      });
    };

    /**
         * Tell the server the user is an employee and fetch the next step
         * If there are multiple registrants, fetch the employee selection form
         * If there is only one registrant, skip this step and go right to the discount questions form
         */
    const isEmployee = () => {
      $.ajax({
        url: document.location.href,
        data: {
          'is-employee': 'yes',
        },
        type: 'post',
      })
        .always(() => {
          elements.$isEmployeeForm.trigger('raceRoster.preventDoubleSubmission.reEnable');
        })
        .done((response) => {
          const $selectEmployees = $(response.content).find(selectors.selectEmployees);

          if (!$selectEmployees.length) {
            completeEmployeeSelection(response);
            return;
          }

          elements.$nextSteps.html($selectEmployees);
          initializeEmployeeSelection(response.nextUrl);
        })
        .fail(alertErrors);
    };

    /**
         * Allow the form to submit normally and proceed to the next step in registration
         */
    const isNotEmployee = () => {
      canSubmit = true;
    };

    /**
         * Fire up
         */
    const initialize = () => {
      elements.$isEmployeeForm.on('submit', () => {
        if (canSubmit) {
          canSubmit = false;
          return true;
        }

        return false;
      });

      elements.$isEmployee.on('click', isEmployee);
      elements.$isNotEmployee.on('click', isNotEmployee);
    };

    initialize();
  };
});
